import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { GET_VISITOR_BY_ID_API } from '../utils/api';
import './VisitorGatePass.css';
import Barcode from 'react-barcode'; 
import Footer from '../components/Footer';


function VisitorGatePass() {
  const { id: visitorId, timestamp: createdAt } = useParams();
  const [visitor, setVisitor] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (visitorId && createdAt) fetchVisitor();
  }, [visitorId, createdAt]);



  const calculateAge = (birthDateStr, referenceDateStr) => {
    const birthDate = new Date(birthDateStr);
    const referenceDate = new Date(referenceDateStr || new Date());

    let years = referenceDate.getFullYear() - birthDate.getFullYear();
    let months = referenceDate.getMonth() - birthDate.getMonth();
    let days = referenceDate.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(referenceDate.getFullYear(), referenceDate.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return { years, months, days };
  };



  const fetchVisitor = async () => {
    try {
      const res = await axios.post(GET_VISITOR_BY_ID_API, {
        visitor_id: visitorId,
        created_at: createdAt,
        token,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setVisitor(res.data.visitor);
      }
    } catch (err) {
      console.error('Error loading visitor gate pass');
    }
  };

  return (
    <>
    <div className="gatepass-print-page">
      {!visitor ? (
        <p>Loading Gate Pass...</p>
      ) : (
        <>
          {/* Header */}
          <div className="gatepass-header">
            <div>
              <h5>{visitor.customer_name}</h5>
              <p>{visitor.customer_address}, {visitor.customer_city}, {visitor.customer_state} - {visitor.customer_pincode}</p>
              {visitor.visitor_serial && (
                <div className="text-center">
                  <Barcode
                    value={visitor.visitor_serial}
                    height={15}

                    displayValue={false}
                  />
                </div>
              )}
            </div>
            <div className="text-end">
              <h4>VISITOR GATE PASS</h4>
              <p><strong>Date:</strong> {visitor.created_at}</p>
              <p><strong>Serial No:</strong> {visitor.visitor_serial}</p>
            </div>
          </div>

          {/* Visitor Info Table */}
          <table className="gatepass-table">
            <tbody>
              <tr>
                <th>Name</th>
                <td>{visitor.name} - {visitor.mobile} ({visitor.sex})</td>
                <td rowSpan="3" className="photo-cell">
                  {visitor.visitor_photo ? (
                    <img
                      src={`data:image/jpeg;base64,${visitor.visitor_photo}`}
                      alt="Visitor"
                      className="visitor-photo"
                    />

                  ) : (
                    <span className="text-muted">No Photo</span>
                  )}
                </td>
              </tr>
              <tr>
                <th>Company</th>
                <td>
                  {visitor.company}, {visitor.company_address},<br />
                  {visitor.district}, {visitor.city}, {visitor.pincode}
                </td>
              </tr>
              <tr>
                <th>Date of Birth <br/>Age</th>
                <td>{visitor.birth_date}
                  {visitor.birth_date && visitor.created_at && (() => {
                    const age = calculateAge(visitor.birth_date, visitor.created_at);
                    const isMinor = age.years < 18;

                    return (
                      <p style={{ color: isMinor ? 'red' : 'inherit' }}>
                         {age.years} years {age.months} months {age.days} days
                        {isMinor && ' (Underage)'}
                      </p>
                    );
                  })()}</td>


              </tr>
              <tr>
                <th>Purpose of Visit</th>
                <td colSpan="2">{visitor.visit_purpose_name}</td>
                  </tr>
              <tr>
                <th>Type of Visitor</th>
                <td colSpan="2">{visitor.visitor_type_name}</td>
              </tr>
<tr>
                <th>Whome to Visit</th>
                <td colSpan="2">{visitor.whom_to_visit_name} - {visitor.whom_to_visit_department || 'N/A'}</td>
              </tr>


              <tr>
                <th>Team Members with Visitors</th>
                <td colSpan="2">{visitor.team_members}</td>
              </tr>
              <tr>
                <th>Allowed Materials</th>
                <td colSpan="2">
                  {Number(visitor.allow_laptop) !== 1 &&
                    Number(visitor.allow_mobile) !== 1 &&
                    Number(visitor.allow_tools) !== 1 ? (
                    <p>❌ None</p>
                  ) : (
                    <ul>
                      {Number(visitor.allow_laptop) === 1 && <li>✅ Laptop</li>}
                      {Number(visitor.allow_mobile) === 1 && <li>✅ Mobile Phone</li>}
                      {Number(visitor.allow_tools) === 1 && <li>✅ Tools</li>}
                    </ul>
                  )}
                </td>
              </tr>
              {visitor.security_materials?.length > 0 && (
                <tr>
                  <th>Issued Security Items</th>
                  <td colSpan="2">
                    <ul className="mb-0">
                      {visitor.security_materials.map((item, index) => (
                        <li key={index}>
                          ✅ {item.name} ({item.qty})
                        </li>
                      ))}
                    </ul>
                  </td>
                </tr>
              )}
              <tr>
                <th>Approval Remark</th>
                <td colSpan="2">{visitor.approval_remark}</td>
              </tr>
            </tbody>
          </table>

          {/* Footer */}
          <div className="gatepass-footer">
  {/* Visitor Signature */}
  <div className="footer-signature">
    <div className="signature-line">&nbsp;</div>
    <p><strong>Visitor Signature</strong></p>
  </div>

  {/* Data Entry By */}
  <div className="footer-signature">
    <div className="signature-line">
      {visitor.created_by_name || '________________'}
    </div>
    <p><strong>Data Entry By</strong></p>
  </div>

  {/* Approver Signature */}
  <div className="footer-signature">
    <div className="signature-line">&nbsp;</div>
    <p><strong>Signature of Approver</strong></p>
  </div>
</div>


          {/* Print Button */}
          <div className="text-center mt-4 no-print">
            <button className="btn btn-primary" onClick={() => window.print()}>
              🖨 Print Gate Pass
            </button>
          </div>
        </>
      )}
     
    </div>
    
      </>
  );
}

export default VisitorGatePass;
